module.exports = __webpack_public_path__ + "static/media/wallLights.16fd2c0b.jpg";